import useMutation from '../../../ReactQuery/useMutation';
import { post } from '../../../redux/api';
import type { ListLicensesAPIRequest, ListLicensesPostRequestBody } from '../../../../shared/types/licenses';
import type { License } from '../../../types';

export type UseListLicensesParams = {
  title?: string;
  pageSize?: number;
  page?: number;
  onlyIds?: boolean;
  idsAndMatches?: boolean;
  licenses?: string[];
};

/**
 * List licenses with large license arrays in the request body
 * to avoid 431 (Request Header Fields Too Large) errors.
 */
const listLicenses = async (params: UseListLicensesParams) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { licenses, title, onlyIds, idsAndMatches, ...queryParams } = params;

  // Transform query params to match API expectations
  const query: ListLicensesAPIRequest = {
    ...queryParams,
    $title: title,
    onlyIds: onlyIds ? 'true' : undefined,
    idsAndMatches: idsAndMatches ? 'true' : undefined,
  };

  const body: ListLicensesPostRequestBody = {
    licenses,
  };

  return post<ListLicensesPostRequestBody, License[]>(
    '/api/licenses',
    body,
    { query },
  );
};

/**
 * Hook for listing licenses with large license ID arrays.
 * Use this when you need to filter by many license IDs (300+)
 * to avoid request header size limits.
 */
export default function useListLicenses() {
  return useMutation<UseListLicensesParams, { data?: License[] }>({
    mutationFn: (params) => listLicenses(params),
  });
}
